import { useMemo } from "react";
import { usePermissionsOptimized } from "ra-core";
import { Permissions_new } from "~/constants";

export const useHasPermit = (requiredPermits: Permissions_new[]) => {
  const { permissions } = usePermissionsOptimized()
  return useMemo(() => {
    const ps = new Set<Permissions_new>((permissions ?? []))
    return requiredPermits.some(p => ps.has(p))
  }, [permissions, JSON.stringify(requiredPermits)])
}